export let inputIsNumber = (input) => {
    if (input) {
        input = input.toString().replace(/\s/gm, "");
    }
    return !isNaN(Number(input)) || "Bare heletal";
}

export let noDecimalMark = (input) => {
    if (input === null || input === undefined) {
        return true;
    }
    return !input.toString().replace(/\s/gm, "").includes('.') || "Bare heletal";
}

export let noDecimal = (input) => {
    if (!input) {
        return `Bare heletal`;
    }

    input = input.toString().replace(/\s/gm, "");
    input = isNaN(Number(input));

    return input % 1 == 0 || "Bare heletal";
}

export let between = (input, min, max) => {
    if (!input) {
        return `${input} < tallet < ${max}`;
    }

    input = input.toString().replace(/\s/gm, "");
    input = isNaN(Number(input));

    return input >= min && input <= max || `${input} < tallet < ${max}`;
}